export function removeAccents(value) {
  for (
    var invalidChar = 'áàãâäéèêëíìîïóòõôöúùûüçñÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇÑ',
      validChar = 'aaaaaeeeeiiiiooooouuuucnAAAAAEEEEIIIIOOOOOUUUUCN',
      newValue = '',
      i = 0;
    i < value.length;
    i++
  ) {
    if (value.charAt(i).match(/[a-zA-ZáàãâäéèêëíìîïóòõôöúùûüçñÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇÑ ]/)) {
      newValue +=
        invalidChar.indexOf(value.charAt(i)) !== -1
          ? validChar.substr(invalidChar.search(value.substr(i, 1)), 1)
          : value.substr(i, 1);
    }
  }

  return newValue;
}

export function leftPad(value, totalWidth, paddingChar) {
  let length = totalWidth - value.toString().length + 1;
  return Array(length).join(paddingChar || '0') + value;
}



// WEBPACK FOOTER //
// ./src/components/utils/ParseUtils.js